module.exports = __webpack_public_path__ + "static/media/share-link-icon-white.86f99253.svg";